import { useEffect, useState } from "react";
import { usePersistStore } from "../store";
import { DASHBOARD_TYPE } from "../utils/enums";

interface InputProps {
  showSwitch: boolean;
}

const HowItWorks: React.FC<InputProps> = ({ showSwitch }) => {
  const { dashboardType } = usePersistStore((s: any) => s);
  const [howItWorksTab, setHowItWorksTab] = useState(dashboardType);

  useEffect(() => {
    setHowItWorksTab(dashboardType);
  }, [dashboardType]);

  return (
    <div className="container">
      <div className="row">
        <div className="col-12 px-md-0 pb-0">
          <div className="row">
            <div className="col-12 pb-4 pt-4">
              <div className="howItWorks__header">
                <span className="howItWorks__kicker">Step by step</span>
                <h2>How it works</h2>
              </div>
            </div>
            <div className="col-12">
              {showSwitch && (
                <div className="d-flex justify-content-center">
                  <div
                    className="dashModeSwitch"
                    role="tablist"
                    aria-label="How it works audience"
                  >
                    <button
                      type="button"
                      role="tab"
                      aria-selected={howItWorksTab === DASHBOARD_TYPE.BUYER}
                      onClick={() => setHowItWorksTab(DASHBOARD_TYPE.BUYER)}
                      className={`dashModeSwitch__opt ${
                        howItWorksTab === DASHBOARD_TYPE.BUYER ? "is-active" : ""
                      }`}
                    >
                      Buyer
                    </button>
                    <button
                      type="button"
                      role="tab"
                      aria-selected={howItWorksTab === DASHBOARD_TYPE.SELLER}
                      onClick={() => setHowItWorksTab(DASHBOARD_TYPE.SELLER)}
                      className={`dashModeSwitch__opt ${
                        howItWorksTab === DASHBOARD_TYPE.SELLER ? "is-active" : ""
                      }`}
                    >
                      Seller
                    </button>
                  </div>
                </div>
              )}
              <div
                className="tab-content howItWorks__content pb-4 pt-5"
                key={howItWorksTab}
              >
                {howItWorksTab === DASHBOARD_TYPE.SELLER ? (
                  <div className="row sellerContent gx-5 pb-5 mb-4 mx-0">
                    <div className="col-lg-4 mb-lg-0 mb-4 text-center position-relative">
                      <img
                        src="/assets/imgs/seller1-icon.svg"
                        className="mb-4"
                        alt=""
                      />
                      <h2 className="mb-4">Register your account</h2>
                      <p>
                        Lorem ipsum dolor sit amet consectetur. Tellus urna
                        morbi non et vulputate malesuada consequat. Facilisis
                        proin libero iaculis lacus.
                      </p>
                      <img
                        src="/assets/imgs/curved-arrow.svg"
                        className="curvedArrow d-lg-block d-none"
                        alt=""
                      />
                    </div>
                    <div className="col-lg-4 mb-lg-0 mb-4 text-center position-relative">
                      <img
                        src="/assets/imgs/seller2-icon.svg"
                        className="mb-4"
                        alt=""
                      />
                      <h2 className="mb-4">Create a listing</h2>
                      <p>
                        Lorem ipsum dolor sit amet consectetur. Tellus urna
                        morbi non et vulputate malesuada consequat. Facilisis
                        proin libero iaculis lacus.
                      </p>
                      <img
                        src="/assets/imgs/curved-arrow-up.svg"
                        className="curvedArrowUp d-lg-block d-none"
                        alt=""
                      />
                    </div>
                    <div className="col-lg-4 mb-lg-0 mb-4 text-center position-relative">
                      <img
                        src="/assets/imgs/seller3-icon.svg"
                        className="mb-4"
                        alt=""
                      />
                      <h2 className="mb-4">Get highest bid and sell</h2>
                      <p>
                        Lorem ipsum dolor sit amet consectetur. Tellus urna
                        morbi non et vulputate malesuada consequat. Facilisis
                        proin libero iaculis lacus.
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="row sellerContent gx-5 pb-5 mb-4 mx-0">
                    <div className="col-lg-4 mb-lg-0 mb-4 text-center position-relative">
                      <img
                        src="/assets/imgs/seller1-icon.svg"
                        className="mb-4"
                        alt=""
                      />
                      <h2 className="mb-4">Register your account</h2>
                      <p>
                        Lorem ipsum dolor sit amet consectetur. Tellus urna
                        morbi non et vulputate malesuada consequat. Facilisis
                        proin libero iaculis lacus.
                      </p>
                      <img
                        src="/assets/imgs/curved-arrow.svg"
                        className="curvedArrow d-lg-block d-none"
                        alt=""
                      />
                    </div>
                    <div className="col-lg-4 mb-lg-0 mb-4 text-center position-relative">
                      <img
                        src="/assets/imgs/seller2-icon.svg"
                        className="mb-4"
                        alt=""
                      />
                      <h2 className="mb-4">Browse and select a Art</h2>
                      <p>
                        Lorem ipsum dolor sit amet consectetur. Tellus urna
                        morbi non et vulputate malesuada consequat. Facilisis
                        proin libero iaculis lacus.
                      </p>
                      <img
                        src="/assets/imgs/curved-arrow-up.svg"
                        className="curvedArrowUp d-lg-block d-none"
                        alt=""
                      />
                    </div>
                    <div className="col-lg-4 mb-lg-0 mb-4 text-center position-relative">
                      <img
                        src="/assets/imgs/seller3-icon.svg"
                        className="mb-4"
                        alt=""
                      />
                      <h2 className="mb-4">Place bids and Monitor</h2>
                      <p>
                        Lorem ipsum dolor sit amet consectetur. Tellus urna
                        morbi non et vulputate malesuada consequat. Facilisis
                        proin libero iaculis lacus.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
